import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaSpinner } from 'react-icons/fa';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);

    // Show button when page is scrolled down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        if (isScrolling) return;

        setIsScrolling(true);

        const scrollStep = -window.scrollY;
        const scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
                setIsScrolling(false);
            }
        }, 15);
    };

    return (
        <>
            {isVisible && (
                <button
                    className={`scroll-to-top ${isScrolling ? 'scrolling' : ''}`}
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                    disabled={isScrolling}
                >
                    {isScrolling ? (
                        <FaSpinner className="spinner" />
                    ) : (
                        <FaArrowUp />
                    )}
                </button>
            )}
        </>
    )
}

export default ScrollToTopButton